import { group, log } from "console";

(function (window, document) {
    if (document.querySelector('.file-list') !== null) {
        const fileList = document.querySelector('.file-list');
        const fileListContent: HTMLTemplateElement = fileList.querySelector('.file-list-content');

        if (!fileListContent) {
            return;
        }

        const groupSelectElement: HTMLSelectElement = fileList.querySelector('[name="filterFiles[group]"]');
        const dateSelectElement: HTMLSelectElement = fileList.querySelector('[name="filterFiles[date]"]');

        const titleElement: HTMLInputElement = fileList.querySelector('[name="filterFiles[title]"]');
        const sortByElement: HTMLInputElement = fileList.querySelector('[name="filterFiles[sortBy]"]');
        const limitElement: HTMLInputElement = fileList.querySelector('[name="filterFiles[limit]"]');
        const nodeIdentifierElement: HTMLInputElement = fileList.querySelector('[name="filterFiles[nodeIdentifier]"]');

        const submitButton: HTMLButtonElement = fileList.querySelector('button[type="submit"]');
        const resetButton: HTMLButtonElement = fileList.querySelector('button[type="reset"]');
        const loadMoreButton: HTMLButtonElement = fileList.querySelector('button.file-list--load-more');

        const tableTemplate: HTMLTemplateElement = fileList.querySelector('#file-list-table');
        const noFilesTemplate: HTMLTemplateElement = fileList.querySelector('#file-list-no-files');
        const loadingSpinner: HTMLTemplateElement = fileList.querySelector('.loading-spinner');

        let offset = parseInt(fileList.getAttribute('data-offset')) || 0;
        const totalItems = parseInt(fileList.getAttribute('data-total-items'));
        const limit = parseInt(limitElement.value) || 12;
        let loading = false;

        const getUrl = () => {
            const url = new URL(window._AVENCY_BASE_actions.fileList, window.origin);
            url.searchParams.set('group', groupSelectElement.value);
            url.searchParams.set('date', dateSelectElement.value);
            if (titleElement) {
                url.searchParams.set('title', titleElement.value);
            }
            url.searchParams.set('sortBy', sortByElement.value);
            url.searchParams.set('offset', offset.toString());
            url.searchParams.set('limit', limit.toString());
            url.searchParams.set('nodeIdentifier', nodeIdentifierElement.value);

            return url;
        }

        const sendRequest = (fromStart = false) => {
            loadMoreButton.classList.add('d-none');
            loadingSpinner.classList.remove('d-none');

            if (fromStart) {
                offset = 0;
            }

            const request = new XMLHttpRequest();
            request.open('GET', getUrl(), true);
            request.onload = function () {
                if (this.status >= 200 && this.status < 400 && this.response !== '') {
                    if (offset > 0) {
                        fileListContent.querySelector('tbody').insertAdjacentHTML('beforeend', this.response);
                    } else {
                        const table = tableTemplate.content.cloneNode(true);
                        fileListContent.replaceChildren(table);
                        fileListContent.querySelector('tbody').innerHTML = this.response;
                    }

                    loading = false;
                    offset += limit;

                    if (fileList.querySelectorAll('.fileItem').length < totalItems) {
                        loadMoreButton.classList.remove('d-none');
                    }
                } else {
                    if (this.response === '') {
                        if (offset === 0) {
                            fileListContent.innerHTML = noFilesTemplate.innerHTML;    
                        }
                    } else {
                        fileListContent.innerHTML = 'Beim Abrufen der Dateien ist ein Fehler aufgetreten.'
                    }

                    loadMoreButton.classList.add('d-none');
                }

                loadingSpinner.classList.add('d-none');
            };
            request.send();
        }

        if (submitButton) {
            submitButton.addEventListener('click', (e) => {
                e.preventDefault();

                sendRequest(true);
            }, {passive: false});
        }

        if (loadMoreButton) {
            loadMoreButton.addEventListener('click', () => {
                sendRequest(false);
            }, {passive: true});
        }

        sendRequest(true);
    }
})(window, document);